<template>
    <main class="c-app-content is-sidebar-tiny">
        <g-loading v-if="firstLoading" />
        <g-table v-else :filter="filterFormModel" :itemCount="itemCount" :items="items" :fields="fields" :isSearch='false' @load="load" @reset="reset"
                 title="Vị trí quan trắc" titleIcon="fa fa-map">
            <template slot="filter">
                <dropdown :right-menu="true" type="bordered" class="mr-2" :model="filterFormModel" attribute="type"  :options="$params.monitoring.typeOptions" :isFilter="true" @change="search" />
            </template>
            <template #cell(type)="{item}">
                <span v-if="item.type" class="badge bg-gray ml-1" >
                    {{$params.monitoring.typeOptions.filter(e => e.value === item.type)[0].text}}
                </span>
            </template>
            <template #cell(blocked)="{item}">
                <div>
                    <span class="small text-gray-999">Trạng thái: </span>
                    <span v-if="item.blocked == 1" class="badge bg-secondary ml-1" > Tạm khóa </span>
                    <span v-else class="badge bg-success ml-1" >Công khai </span>
                </div>
            </template>
            <template slot="action">
                <g-button :loading="saveLoading" v-if="permissions('monitoring-place_create')"  size="sm" variant="success" icon="fa fa-plus" content="Thêm mới"  @click="create" />
            </template>
            <template #cell(action)="{item}">
                <g-button v-if="permissions('monitoring-place_update')"  :loading="updateLoading" size="sm" variant="outline-info" class="ml-1 mb-1" icon="pencil" @click="update(item.id)"  />
                <g-button v-if="permissions('monitoring-place_del')"  :loading="delLoading" size="sm" variant="outline-danger" class="ml-1 mb-1"   icon="trash-fill" @click='del(item.id)' />
            </template>
        </g-table>
        <b-modal v-model="showForm" size="md" :title="formTitle" @ok="save" no-close-on-backdrop no-enforce-focus>
            <form-select label="Loại quan trắc"  :required='true'  :model="formModel" attribute="type" :multiple="false" :errors="formErrors" :close-on-select='true' :options="$params.monitoring.typeOptions"/>
            <form-input  label="Tên vị trí" :required='true' :model="formModel" attribute="title" :errors="formErrors"/>
            <form-input  label="Đường dẫn" :required='true' :model="formModel" attribute="slug" :errors="formErrors"/>
            <div class="row">
                <div class="col-md-6">
                    <form-input  label="Vĩ độ (Latitude)" :required='false' :model="formModel" attribute="latitude" :errors="formErrors"/>
                </div>
                <div class="col-md-6">
                    <form-input  label="Kinh độ (Longitude)" :required='false' :model="formModel" attribute="longitude" :errors="formErrors"/>
                </div>
            </div>
            <form-checkbox chk-label="Tạm khoá" :model="formModel" :errors="formErrors"  attribute="blocked" />
            <template v-slot:modal-footer="{ ok, cancel}">
                <b-button variant="secondary" class="float-right" @click="cancel">Đóng</b-button>
                <b-button :disabled="saveLoading" variant="primary" class="float-right" @click="ok">
                    <b-spinner v-if="saveLoading" small></b-spinner>
                    <em v-else class="fa fa-save" ></em>
                    Lưu lại
                </b-button>
            </template>
        </b-modal>
    </main>
</template>

<script>
    import list from "@/mixins/List";
    import crud from '@/mixins/CRUD';
    import role from '@/mixins/Role';
    import Dropdown from '@/components/Dropdown';

    export default {
        components: {Dropdown},
        mixins: [list, crud, role],
        data: function () {
            return {
                reloadBus: "reloadKeyword",
                service: '/monitoring-place',
                fields: [
                    {key: 'title', label: "Vị trí quan trắc", class: 'text-left'},
                    {key: 'type', label: "Loại quan trắc", class: 'text-left'},
                    {key: 'blocked', label: "Trạng thái", class: 'text-left'},
                    {key: 'action', label: "Hành động", class: 'text-right'},
                ],
                defaultFilterFormModel: {
                    keyword: '',
                    type: null,
                },
                defaultFormModel: {
                    title: null,
                    slug: null,
                    type: null
                },
            }

        },
        watch: {
            "formModel.title": {
                handler(val) {
                    if (val && (!this.formModel.id || !this.formModel.slug)) {
                        this.formModel.slug = this.$utils.createCode(val);
                    }
                }, deep: true
            },
            "formModel.slug": {
                handler(val) {
                    if (val) {
                        this.formModel.slug = this.$utils.createCode(val);
                    }
                }, deep: true
            }
        },
        methods: {
        },
        mounted() {
            
        }
    }
</script>